import React, { useEffect, useState } from "react";
import { ChevronDown } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { getFaqs } from "../redux/Thunk/providerThunk";

const Faqs = () => {
  const dispatch = useDispatch();
  const [faq, setFaq] = useState([]);

  // useEffect(() => {
    // This shows unathorized error
  //   dispatch(getFaqs())
  //     .unwrap()
  //     .then((res) => {
  //       console.log("The res is :", res.data);
  //     });
  // }, [dispatch]);
  const faqss = [
    {
      question: "Is TiffinTap App really free?",
      answer:
        "Yes. TiffinTap is free forever for small tiffin service providers. We know what it feels like to count every penny, that’s why we made sure you don’t pay until you grow your business.",
    },
    {
      question: "Does TiffinTap take a commission from my earnings",
      answer:
        "Never. We built TiffinTap after struggling with apps and platforms that charged a commission on every order. As tiffin suppliers, we knew how unfair that was. With TiffinTap, your money is your money. You only pay a small fixed fee once you start serving enough orders.",
    },
    {
      question: "How much does the Growth Plan cost?",
      answer:
        "Just $15/month (local currency equivalent). We kept it intentionally affordable — the price of one tiffin meal — so that it feels light on your pocket. And remember: you don’t need to pay if you are a small tiffin service provider.",
    },
    {
      question: "Can I cancel my subscription anytime?",
      answer:
        "Yes. No lock-ins, no contracts. We know what it’s like to try and then stop — so we kept it flexible.",
    },
    {
      question: "Do I need technical knowledge to use this app?",
      answer:
        "Not at all. We built TiffinTap to feel just as simple — if you can use WhatsApp to manage your existing tiffin business, you can use this app.",
    },
    {
      question: "What about payments? How will my customers pay me?",
      answer:
        "Your customers still pay you directly (cash, UPI, transfer). TiffinTap simply keeps records on your behalf so you always know who paid, who didn’t, and what’s pending. This is the biggest struggle you face when running a tiffin business, so we made sure this pain is solved without our involvement in payment.",
    },
    {
      question: "Can my customers cancel orders?",
      answer:
        "Yes — but only before the cut-off time that you set in the app. As providers ourselves, we know the frustration of last-minute cancellations. That’s why we gave you control to define the cut-off (for lunch/dinner).",
    },
    {
      question: "Is my data safe?",
      answer:
        "Yes. Your data is securely stored on AWS servers. And since we built this app as former tiffin providers, we’re committed to keeping your trust — your customer list stays private to you.",
    },
    {
      question: "What if my customer shares the link with others?",
      answer:
        "If your customer forwards the link, the new customers will be able to access your tiffin service profile and can place orders if they want. We've made sure that each customer’s orders and payments are kept separate. You grow faster because new people can discover your service through sharing — but without mixing up accounts or histories.",
    },
    {
      question: "What if I need help using the app?",
      answer:
        "We’re always here to help. As a tiffin provider you can get queries section inside the app, so you can reach us directly if you ever have a question.",
    },
  ];

  const [openIndex, setOpenIndex] = useState(null);

  const handleFaqClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <div className="space-y-4">
        {faqss.map((faq, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={index}
              className="border border-orange-200 rounded-xl p-3 bg-white/70 transition-all duration-300"
            >
              {/* Header */}
              <div
                className="flex justify-between items-center cursor-pointer"
                onClick={() => handleFaqClick(index)}
              >
                <h3
                  className={`text-md md:text-md font-body font-semibold transition-colors duration-300 ${
                    isOpen ? "text-orange-500" : "text-black"
                  }`}
                >
                  {faq.question}
                </h3>

                <ChevronDown
                  className={`transition-transform duration-500 ${
                    isOpen ? "rotate-180 text-orange-500" : "rotate-0"
                  }`}
                />
              </div>

              {/* Animated Content */}
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  isOpen ? "max-h-40 opacity-100 mt-4" : "max-h-0 opacity-0"
                }`}
              >
                <p className="text-sm md:text-base text-gray-600">
                  {faq.answer}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Faqs;
